<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card treeBox" style="height: calc(100vh - 152px);width: 200px;overflow-y: auto">
            <el-tree :data="orgData" @node-click="clickOrg" default-expand-all :expand-on-click-node="false"></el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <div class="newBox" style="width: calc(100% - 210px)">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>用户名：</label>
                    <el-input v-model="search_Obj.f_username" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>姓名：</label>
                    <el-input v-model="search_Obj.f_realname" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>状态：</label>
                    <el-select v-model="search_Obj.f_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('userstate')" :key="'userstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
            </div>
            <el-card ref="right_content" class="box-card">
                <div class="mainBody">
                    <div class="btnBox">
                        <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                    </div>
                    <div class="dataBox">
                        <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                            <el-table-column type="selection" align="center" width="50"></el-table-column>
                            <el-table-column prop="username" label="用户名" sortable="custom" width="150"></el-table-column>
                            <el-table-column prop="realname" label="姓名" sortable="custom" width="150"></el-table-column>
                            <el-table-column prop="org_name" label="所在机构" sortable="custom"></el-table-column>
                            <el-table-column prop="state" label="状态" sortable="custom" width="120">
                                <template slot-scope="scope">
                                    <span>{{ transEnu(scope.row.state, "userstate") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="rolenames" label="角色信息" sortable="custom"></el-table-column>
                            <el-table-column prop="lastlogindate" label="最后登录" sortable="custom"></el-table-column>
                            <el-table-column label="操作" width="320" align="center">
                                <template slot-scope="scope">
                                    <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pageBox">
                        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
        <SetRole
            width="400px"
            :id="model_id"
            title="分配角色"
            :isshow="infoshow"
            @on-close="closeRoleDialog">
        </SetRole>
        <SetRoleBatch
            width="400px"
            title="批量分配角色"
            :id="model_id"
            :isshow="rolebatchshow"
            @select-ok="selRoleBatchOk"
            @on-close="closeRoleBatchDialog">
        </SetRoleBatch>
        <Import
            width="600px"
            title="导入用户"
            :isshow="importshow"
            @on-close="closeImportDialog"
            @on-imp-ok="impOk">
        </Import>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
    </div>
</template>

<script>
import Btns from "@/components/common/btns";
import LabBtns from "@/components/common/labbtns";
import Edit from "./edit";
import Import from "./import"
import SetRole from "./setrole";
import SetRoleBatch from "./setrolebatch";
import listutil from "@/libs/listutil";
import { resetPass, saveRoleBatch } from "@/api/user";
import { getOrgTreeData } from '@/api/org'

export default {
    name: 'userList',
    mixins: [listutil],
    components: {Edit, Import, SetRole, SetRoleBatch, Btns, LabBtns},
    data() {
        return {
            m_name: '用户',
            menu_id: 1100,
            list_url: "/api/admin/user/list",
            enu_name: ["userstate"],
            search_Obj: {
                f_username: '',
                f_realname: '',
                f_state: '',
                org_id: '',
            },
            del_Obj:{
                url:'/api/admin/user/del',
                data:{
                    ids:''
                }
            },
            orgData: [],
            importshow: false,
            rolebatchshow: false,
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        resetPassword(index, row){
            this.$confirm('确定要重置用户【'+row.realname+'】的密码吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                resetPass(row.id).then(res=>{
                    if(res.code ==1){
                        this.$msgs(res.msg)
                    }else{
                        this.$msg(res.msg)
                    }
                })
            }).catch(() => {})
        },
        roleSet(index, row){
            this.model_id = row.id
            this.infoshow = true
        },
        closeRoleDialog(){
            this.infoshow = false
            this.getListData()
        },
        roleSetBatch(){
            if (this.selectData.length <= 0) {
                this.$msg("请选择要分配角色的用户")
            }else{
                this.model_id = this.selectData[0].id
                this.rolebatchshow = true
            }
        },
        selRoleBatchOk(role_ids){
            if (this.selectData.length <= 0) {
                this.$msg("请选择要分配角色的用户")
            } else {
                let ids = '';
                for (let data of this.selectData) {
                    if (ids === '') {
                        ids = data.id + "";
                    } else {
                        ids += "," + data.id;
                    }
                }
                saveRoleBatch(role_ids, ids).then(res=>{
                    if (res.code == 1) {
                        this.$msgs("批量添加角色成功")
                        this.closeRoleBatchDialog()
                    } else {
                        this.$msg(res.msg)
                    }
                })
            }
        },
        closeRoleBatchDialog(){
            this.rolebatchshow = false
            this.getListData()
        },
        loadOtherData() {
            this.orgData = []
            getOrgTreeData().then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.orgData = treeData
                }
            })
        },
        clickOrg(data){
            this.search_Obj.org_id = data.id
            this.getListData()
        },
        import(){
            this.importshow = true
        },
        impOk(){
            this.importshow = false
            this.getListData()
        },
        closeImportDialog(){
            this.importshow = false
        }
    }
};
</script>